import React from 'react';

import { connect, useSelector } from 'react-redux';
import Icons from 'consts/icons';
import Auth from 'auth/Auth';
import Fade from '@material-ui/core/Fade';

import { SidebarMenuUseStyles } from './SidebarMenuUseStyles';
import SidebarMenuDetails from './SidebarMenuDetails';

const SidebarMenu = () => {
  const classes = SidebarMenuUseStyles();

  const auth = new Auth();
  const isAdmin = () => auth.isAdmin();

  const [items, setItems] = React.useState([]);
  const [activeItem, setActiveItem] = React.useState('dashboard');

  const useString = () => {
    const language = useSelector(state => state.language);

    return language;
  };
  const subtitles = useString().sidebar;

  React.useEffect(() => {
    setItems([
      {
        name: 'profile',
        icon: <Icons.Profile.ProfileSettings />,
      },
      {
        name: 'dashboard',
        icon: <Icons.Dashboard.Dashboard />,
      },
      {
        name: 'uspace',
        icon: <Icons.USpace.History />,
      },
      {
        name: 'airspace',
        icon: <Icons.Airspace.AirControl />,
      },
      {
        name: 'settings',
        icon: <Icons.Dashboard.Settings />,
      },
      {
        name: 'admin',
        icon: <Icons.Dashboard.Key />,
      },
    ]);
  }, []);
  return (
    <>
      <Fade in={activeItem !== null}>
        <div>
          <SidebarMenuDetails details={activeItem} isAdmin={isAdmin} />
        </div>
      </Fade>

      <div className={classes.SidebarMenu}>
        <div className={`${classes.SidebarMenu}__nav`}>
          <div className={`${classes.SidebarMenu}__nav__list`}>
            {items?.map((item, index) =>
              item?.name !== 'admin' ||
              (item?.name === 'admin' && isAdmin()) ? (
                <div
                  key={`${index}-${item.name}`}
                  className={`${classes.SidebarMenu}__nav__list__item ${
                    activeItem === item?.name ? 'active' : ''
                  }`}
                  onClick={() => setActiveItem(item?.name)}
                  aria-hidden="true"
                  role="button"
                >
                  {item?.name === 'settings' ? (
                    <div
                      className={`${classes.SidebarMenu}__nav__list__item__hr ${classes.SidebarMenu}__nav__list__item__hr--left`}
                    ></div>
                  ) : null}
                  <div
                    className={`${classes.SidebarMenu}__nav__list__item__box`}
                  >
                    <div
                      className={`${classes.SidebarMenu}__nav__list__item__box__icon`}
                    >
                      {item?.icon}
                    </div>
                    <span
                      className={`${classes.SidebarMenu}__nav__list__item__box__text`}
                    >
                      {subtitles[`${item?.name}_`]}
                    </span>
                  </div>
                  {item?.name === 'profile' ? (
                    <div
                      className={`${classes.SidebarMenu}__nav__list__item__hr ${classes.SidebarMenu}__nav__list__item__hr--right`}
                    ></div>
                  ) : null}
                </div>
              ) : null
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  map: state.map,
  selectedMissionsApprovals: state.selectedDashboardMissionsApprovals,
  selectedOperationsApprovals: state.selectedDashboardOperationsApprovals,
});

export default connect(mapStateToProps)(SidebarMenu);
